export enum ModalIds {
    PREVIEW_ARTICLE = 'PREVIEW_ARTICLE',
    SPECIALIST_FORM = 'SPECIALIST_FORM',
    SPECIALIST_DELETE_CONFIRM = 'SPECIALIST_DELETE_CONFIRM',
    ARTICLE_DELETE_CONFIRM = 'ARTICLE_DELETE_CONFIRM',
    ARTICLE_DELETE_BLOCKED_UNIVERSAL = 'ARTICLE_DELETE_BLOCKED_UNIVERSAL',
    PRINT_ARTICLE = 'PRINT_ARTICLE',
    ARTICLE_QR_INFO = 'ARTICLE_QR_INFO',
    SHARE_ARTICLE = 'SHARE_ARTICLE',
    ARTICLE_CONVERT_WITH_AI = 'ARTICLE_CONVERT_WITH_AI',
    ARTICLE_AI_CONVERTED_PREVIEW = 'ARTICLE_AI_CONVERTED_PREVIEW',
    ARTICLE_AI_ERROR_RESPONSE = 'ARTICLE_AI_ERROR_RESPONSE',
    VISIT_REQUIREMENT_PREVIEW = 'VISIT_REQUIREMENT_PREVIEW',
    ARTICLE_PUBLISH_CONFIRM = 'ARTICLE_PUBLISH_CONFIRM',
    WIDGET_DEACTIVATE_CONFIRM = 'WIDGET_DEACTIVATE_CONFIRM',
    LOGOUT_CONFIRM = 'LOGOUT_CONFIRM',
    IMAGE_CROPPER = 'IMAGE_CROPPER',
}
